<template>
  <div class="relative z-20 bg-gray-200">
    <article
      class="flex h-full min-h-[100vh]"
      :class="isDesktop && 'container-wrap'"
    >
      <AreaCategoryCategories />
      <AreaCategoryCollections :is-loading="isLoading" />
    </article>
    <div class="absolute left-[30vw] top-0 z-10 h-full w-full bg-gray-100" />
  </div>
</template>

<script setup lang="ts">
  definePageMeta({
    pageTransition: false,
    middleware: ['category-redirect'],
  });

  const { t } = useI18n();
  const route = useRoute();
  const { isDesktop } = useScreen();
  const { provideWebTitle } = useWebsite();

  const categoryCode = route.params.subcategory;

  const title = t(`menu.product.category.${categoryCode}`);
  const description = t(`meta.category.${categoryCode}`);

  const categoryStore = useCategoryStore();
  const { status } = await categoryStore.USE_GET_PRODUCTS();

  const isLoading = computed((): boolean => status.value !== 'success');

  watch(
    status,
    () => {
      if (status.value === 'error') {
        showError({ statusCode: 404 });
      }
    },
    { immediate: true }
  );

  useSeoMeta({
    title: () => title,
    ogTitle: () => provideWebTitle(title),
    twitterTitle: () => provideWebTitle(title),
    description: () => description,
    ogDescription: () => description,
    twitterDescription: () => description,
  });
</script>
